import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.homepage',
    modules: [
        R,
    ],
})
@Service('HomepageStore')
export default class Store {
    constructor (R) {
        "ngInject";
        this.R = R;
        this.endpoint = this.R.one('homepage');
    }

    get () {
        return this.endpoint.get();
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/homepage.js